export const classes = {
  field:
    'relative block border-b-[1.5px] border-[rgba(70,60,50,0.18)] transition-colors duration-[160ms] ease-[ease] focus-within:border-b-brand-accent dark:border-[rgba(255,255,255,0.16)] dark:focus-within:border-b-brand-accent-dark',
  default: 'px-0.5 pb-2 pt-[18px]',
  compact: 'px-0.5 pb-[7px] pt-[17px]',
  label:
    'pointer-events-none absolute left-[2px] top-[18px] origin-top-left text-[15px] font-normal leading-none text-taupe-1 transition-[transform,color,font-weight] duration-[160ms] ease-[ease] dark:text-mauve-3',
  labelCompact: 'top-[17px] text-[14.5px]',
  input:
    'w-full border-none bg-transparent text-[15px] text-taupe-3 outline-none placeholder:text-transparent dark:text-mauve-1',
  inputCompact: 'text-[14.5px]',
  password: 'tracking-[0.08em]',
};

export const styles = {
  field: {
    '&:focus-within > span, &:has(input:not(:placeholder-shown)) > span': {
      transform: 'translateY(-17px) scale(0.8)',
      fontWeight: 500,
    },
    '&:focus-within > span': { color: '#f15a2b' },
    '.dark &:focus-within > span': { color: '#ff7a4d' },
  },
};
